import validator from 'validator';
import numeral from "../utils/numeral";

export function required(txt) {
    return txt !== undefined && !validator.isEmpty(txt);
}

export function notEmpty(obj) {
    return obj !== null && obj !== undefined;
}

export function email(txt) {
    return txt !== undefined && validator.isEmail(txt);
}

export function invoiceNumbers(txt) {
    return txt !== undefined && numeral(txt).value() > 0 && txt.match(/^(\d{10})(,\d{10})*$/) !== null;
}

export function positive(txt) {
    return txt !== undefined && txt !== '' && numeral(txt).value() > 0;
}

export function onlyNumbers(txt) {
    return txt !== undefined && txt.match(/^[0-9]+$/) !== null;
}

export function length(length) {
    return txt => txt !== undefined && txt.length === length;
}

export function minLength(length) {
    return txt => txt !== undefined && txt.length >= length;
}

export function maxLength(length) {
    return txt => txt !== undefined && txt.length <= length;
}

export function maxValue(max) {
    return txt => txt !== undefined && txt <= max;
}

export function validateData(validations, data) {
    return Object.keys(validations).reduce((obj, key) => {
        const reverseArray = reverseArr(validations[key]);
        for (var idx in reverseArray) {
            const validate = reverseArray[idx].fn;
            if (data[key] !== undefined && !validate(data[key])) {
                obj[key] = reverseArray[idx].msg;
            }
        }
        return obj;
    }, {});
}

function reverseArr(input) {
    var ret = new Array();
    for (var i = input.length - 1; i >= 0; i--) {
        ret.push(input[i]);
    }
    return ret;
}